import { tr } from '../services/i18n.js';

export const DEBRIEF_VISIBILITY = {
  PUBLIC: 'public',
  FRIENDS: 'friends',
  PRIVATE: 'private'
};

const VISIBILITY_OPTIONS = [
  {
    value: DEBRIEF_VISIBILITY.PUBLIC,
    label: 'Public',
    badge: 'Visible par tous',
    description: 'Apparait dans le feed de tous les utilisateurs.'
  },
  {
    value: DEBRIEF_VISIBILITY.FRIENDS,
    label: 'Amis',
    badge: 'Amis seulement',
    description: 'Visible uniquement par tes amis acceptes.'
  },
  {
    value: DEBRIEF_VISIBILITY.PRIVATE,
    label: 'Prive',
    badge: 'Prive',
    description: 'Visible uniquement par toi.'
  }
];

const VISIBILITY_TRANSLATIONS = {
  public: {
    label: 'Public',
    badge: 'Visible to everyone',
    description: "Appears in every user's feed."
  },
  friends: {
    label: 'Friends',
    badge: 'Friends only',
    description: 'Visible only to your accepted friends.'
  },
  private: {
    label: 'Private',
    badge: 'Private',
    description: 'Visible only to you.'
  }
};

export const DEBRIEF_VISIBILITY_OPTIONS = VISIBILITY_OPTIONS;

export function localizedDebriefVisibilityOptions() {
  return VISIBILITY_OPTIONS.map((option) => {
    const translated = VISIBILITY_TRANSLATIONS[option.value];
    return {
      ...option,
      label: tr(option.label, translated?.label || option.label),
      badge: tr(option.badge, translated?.badge || option.badge),
      description: tr(option.description, translated?.description || option.description)
    };
  });
}

export function normalizeDebriefVisibility(value) {
  return DEBRIEF_VISIBILITY_OPTIONS.some((option) => option.value === value)
    ? value
    : DEBRIEF_VISIBILITY.PUBLIC;
}

export function debriefVisibilityOption(value) {
  const normalized = normalizeDebriefVisibility(value);
  return localizedDebriefVisibilityOptions().find((option) => option.value === normalized);
}
